import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"

interface UseArchivePrivateCompanyProps {
  privateCompanyLeadId?: string
  onSuccess?: () => void
  onError?: () => void
}

export const useArchivePrivateCompanyLead = ({
  privateCompanyLeadId,
  onSuccess,
  onError,
}: UseArchivePrivateCompanyProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['archivePrivateCompany'],
    mutationFn: async (newStatus: string) => {
      await privateAxios.put(`/funnel/private_company_leads/${privateCompanyLeadId}/${newStatus}`)
    },
    onSuccess,
    onError,
  })
}
